import _extends from "@babel/runtime/helpers/esm/extends";
import * as helpers from 'dom-lib';
export * from 'dom-lib';

var DOMHelper = _extends({}, helpers, {
  isElement: function isElement(node) {
    return (node === null || node === void 0 ? void 0 : node.nodeType) && typeof (node === null || node === void 0 ? void 0 : node.nodeName) === 'string';
  }
});

export default DOMHelper;